import { apiService } from '.';
import { Project, ProjectFilter } from '../shared/types/project';

export const asyncGetProjects = async (
    filters?: ProjectFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: Project[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: Project[]; length: number };
        } = await apiService.get('/api/project', {
            page: page || 0,
            ...(pageSize ? { limit: pageSize } : {}),
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetProject = async (
    idProject: string
): Promise<Project | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Project;
        } = await apiService.get(`/api/project/${idProject}`);

        return data;
    } catch (error) {}
};

export const asyncCreateProject = async (
    info: Project
): Promise<Project | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Project;
        } = await apiService.post('/api/project', info);
        return data;
    } catch (error) {}
};

export const asyncUpdateProject = async (
    id: string,
    project: Project
): Promise<Project | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Project;
        } = await apiService.patch(`/api/project/${id}`, project);

        return data;
    } catch (error) {}
};

export const asyncDeleteProject = async (id: string | number) => {
    return await apiService.delete(`/api/project/${id}`);
};
